export default "__VITE_ASSET__DQf4FhTP__"